var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"d-flex justify-content-between flex-nowrap container"},[_vm._t("label"),_vm._v(" "),_vm._t("form")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }